// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// Project Imports
import PrivateRouteConst from 'core/common/privateRouteConstant';
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

const ClawbackFileUpload = lazy(
  () => import('pages/clawbackFileUpload/clawbackFileUpload')
);
const ClawbackFileUploadRoute = (
  <Route path={routeName.contractCancellationUpload}>
    <Route
      index
      element={
        <PrivateRoute name={[PrivateRouteConst.CANCELLATION_FILE_UPLOAD]}>
          <Suspense
            fallback={
              <div>
                <Loading />
              </div>
            }
          >
            <ClawbackFileUpload />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default ClawbackFileUploadRoute;
